// Gradient AI/ML Club Content Data

export const siteConfig = {
  name: "Gradient",
  tagline: "Redefining Intelligence",
  description: "Pioneering the future through AI and Machine Learning innovation at B.M.S. College of Engineering.",
  founded: 2022,
  social: {
    instagram: "https://instagram.com/gradient.aiml",
    linkedin: "https://linkedin.com/company/gradient-club",
  }
};

export const stats = [
  { value: "60+", label: "Events Conducted", suffix: "" },
  { value: "3750+", label: "Participants", suffix: "" },
  { value: "300+", label: "Community Members", suffix: "" },
];

export const pillars = [
  {
    id: "workshops",
    title: "Technical Workshops",
    description: "Hands-on workshops and seminars on cutting-edge AI and ML technologies",
    icon: "Code"
  },
  {
    id: "hackathons", 
    title: "Hackathons",
    description: "Competitive coding events and AI project challenges",
    icon: "Trophy"
  },
  {
    id: "events",
    title: "Technical Events",
    description: "Collaborative, fun and innovative events with real-world applications",
    icon: "Sparkles"
  }
];

export const timeline = [
  {
    year: 2022,
    title: "The Beginning",
    description: "Gradient was founded with the aim of reaching new heights in AI/ML education.",
    highlight: "Inauguration Ceremony"
  },
  {
    year: 2023,
    title: "First Core Team",
    description: "The founding core team established the foundation for Gradient's future.",
    highlight: "First Events Launched"
  },
  {
    year: 2024,
    title: "Growth Era",
    description: "Expanded to 200+ members, hosted major hackathons and workshops.",
    highlight: "Biggest Hackathon"
  },
  {
    year: 2025,
    title: "Innovation Peak",
    description: "Gradient Week, Utsav Ananta collaborations, and groundbreaking events.",
    highlight: "Gradient Week 2025"
  }
];

export const teamDomains = [
  {
    id: "coordinator",
    title: "Coordinator",
    animation: "pulse",
    color: "#7C3AED",
    members: [
      { name: "Faculty Coordinator", role: "Faculty Advisor", image: "https://gradient-content-server.vercel.app/content/core26/faculty.jpg" }
    ]
  },
  {
    id: "tech",
    title: "Tech Heads",
    animation: "orbit",
    color: "#A891FF",
    members: [
      { name: "Pranav Veeraghanta", role: "Technical Head", image: "https://gradient-content-server.vercel.app/content/core26/pranav.jpg", link: "https://beyondmebtw.com/" }
    ]
  },
  {
    id: "design",
    title: "Design Heads", 
    animation: "morph",
    color: "#D4C5FF",
    members: [
      { name: "Vinay Yele", role: "Design Head", image: "https://gradient-content-server.vercel.app/content/core26/vinay.jpg", link: "https://vinayyele.live/" }
    ]
  },
  {
    id: "logistics",
    title: "Logistics Heads",
    animation: "wave",
    color: "#ff6b00",
    members: []
  },
  {
    id: "content",
    title: "Content Heads",
    animation: "typewriter",
    color: "#00ff88",
    members: []
  },
  {
    id: "outreach",
    title: "Outreach Heads",
    animation: "network",
    color: "#ffcc00",
    members: []
  }
];

export const events = {
  utsav: {
    title: "Utsav Ananta",
    description: "The annual cultural festival of BMSCE where Gradient celebrates art, music, and creative expression.",
    years: {
      2025: [
        { name: "Jokes on You Again", image: "https://gradient-content-server.vercel.app/content/utsav25/JOY.png", status: "completed" },
        { name: "Uncharted 3: Lost Voyage", image: "https://gradient-content-server.vercel.app/content/utsav25/UNC.png", status: "completed" },
        { name: "Sync or Sink", image: "https://gradient-content-server.vercel.app/content/utsav25/SOS.png", status: "completed" }
      ]
    }
  },
  phaseshift: {
    title: "PhaseShift Meridian",
    description: "BMSCE's premier technical symposium featuring innovative workshops and showcases.",
    years: {
      2025: []
    }
  },
  gradientWeek: {
    title: "Gradient Week",
    description: "Our flagship annual Tech Innovation Week featuring hackathons, workshops, and tech showcases.",
    years: {
      2025: []
    }
  }
};

export const specialShowcases = [
  {
    title: "Uncharted Lost Voyage",
    description: "Dive into Gradient's immersive game, where interconnected websites hide cryptic clues and thrilling puzzles.",
    image: "https://gradient-content-server.vercel.app/content/utsav25/gallery/unc/ulvfs.png",
    link: "https://uncharted3.gradientaiml.tech/"
  },
  {
    title: "Gradient Week 2025",
    description: "Explore the official page for Gradient Week 2025, our flagship annual Tech Innovation Week.",
    image: "https://gradient-content-server.vercel.app/content/gallery/special/3.webp",
    link: "https://gradientaiml.tech/gw25"
  },
  {
    title: "Gradient Week 2025 Recap",
    description: "Relive the highlights and memorable moments from Gradient Week 2025.",
    image: "https://gradient-content-server.vercel.app/content/gallery/special/4.webp",
    link: "https://gradientaiml.tech/gw25recap"
  }
];
